import React from "react";
import { HashRouter as Router } from "react-router-dom";
import { isIE } from "react-device-detect";
import "./lib/i18n";
import Routes from "./common/Routes";
import PageLayout from "./components/PageLayout";
import LoadingInterceptor from "./components/LoadingInterceptor";
import { CoreProvider } from "./contexts/coreContext";
import { AlertProvider } from "./contexts/alertContext";
import IddleContext from "./contexts/IddleContex";
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.compact.css";

import "normalize.css";
import "@blueprintjs/core/lib/css/blueprint.css";
import "@blueprintjs/icons/lib/css/blueprint-icons.css";
import "@blueprintjs/datetime/lib/css/blueprint-datetime.css";

import "@fortawesome/fontawesome-free/css/all.min.css";
import StoreContext from "contexts/storeContext";
import ToasterContext from "contexts/ToasterContext";

import IEBrowser from "contents/IEBrowser";

function App() {
  return (
    <div className="App">
      {isIE ? (
        <IEBrowser />
      ) : (
        // <p>Uyumsuz tarayıcı</p>
        <>
          
          <CoreProvider>
          <LoadingInterceptor />
            <StoreContext>
              <AlertProvider>
                <IddleContext>
                  <ToasterContext>
                    <Router>
                      <PageLayout>
                        <Routes />
                      </PageLayout>
                    </Router>
                  </ToasterContext>
                </IddleContext>
              </AlertProvider>
            </StoreContext>
          </CoreProvider>
        </>
      )}
    </div>
  );
}

export default App;
